/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {FormikValues} from 'formik'
import DatePicker from 'react-datepicker'

const AddTenantStep4 = ({formik}: FormikValues) => {
  const [agreementDate, setAgreementDate] = useState(null)
  const [tenancyStartDate, setTenancyStartDate] = useState(null)
  const [tenancyEndDate, setTenancyEndDate] = useState(null)
  const dueDates = Array.from({length: 31}, (_, index) => index + 1)

  const FormatDate = (date: any) => {
    const formattedDate = date.toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    return formattedDate
  }
  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100'>
        {/*begin::Form Group Rent Due Date */}
        <div className='fv-row mb-6'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Rent Due Date</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose rent due date'
            ></i>
          </label>
          <select
            className='form-select form-select-solid d-flex'
            name='property_rent_due_date'
            placeholder='Select due date'
            {...formik.getFieldProps('property_rent_due_date')}
          >
            <option className='bg-color-gray' value=''>
              Select due date
            </option>
            {dueDates.map((item: any) => {
              return (
                <option key={item} value={item}>
                  {item}
                </option>
              )
            })}
          </select>
          <div className='h-20px'>
            {formik.touched.property_rent_due_date && formik.errors.property_rent_due_date && (
              <div className='fv-help-block color-red'>{formik.errors.property_rent_due_date}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Rent Due Date*/}

        {/* begin::Rental Agreement Date */}
        {/* <div className='w-100 d-flex justify-content-between'> */}
        {/* begin::Rental Agreement Start Date */}
        <div className='fv-row mb-6'>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Agreement Date</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose rental agreement date'
            ></i>
          </label>
          <DatePicker
            autoComplete='off'
            selected={agreementDate}
            dateFormat='yyyy/MM/dd'
            placeholderText='Select agreement date'
            onChange={(date: any) => {
              formik.setFieldTouched('rental_agreement_date', true, true)
              if (date === null) {
                setAgreementDate(null)
                formik.setFieldValue('rental_agreement_date', '')
              } else {
                setAgreementDate(date)
                formik.setFieldValue('rental_agreement_date', FormatDate(date))
              }
            }}
            className='form-control form-control-lg form-control-solid'
          />
          <div className='h-20px'>
            {formik.touched.rental_agreement_date && formik.errors.rental_agreement_date && (
              <div className='fv-help-block color-red'>{formik.errors.rental_agreement_date}</div>
            )}
          </div>
        </div>
        {/* end::Rental Agreement Start Date */}

        {/* begin::Rental Agreement End Date */}
        {/* <div className='fv-row' style={{width: '45%'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Agreement End Date</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose rental agreement end date'
              ></i>
            </label>
            <DatePicker
              autoComplete='off'
              selected={agreementEndDate}
              dateFormat='yyyy/MM/dd'
              selectsEnd
              startDate={agreementStartDate}
              endDate={agreementEndDate}
              minDate={agreementStartDate}
              onChange={(date: any) => {
                setAgreementEndDate(date)
                formik.setFieldValue('property_rent_end_date', FormatDate(date))
              }}
              className='form-control form-control-lg form-control-solid'
            />

            <div className='h-20px'>
              {formik.touched.property_rent_end_date && formik.errors.property_rent_end_date && (
                <div className='fv-help-block color-red'>
                  {formik.errors.property_rent_end_date}
                </div>
              )}
            </div>
          </div> */}
        {/* end::Rental Agreement End Date */}
        {/* </div> */}
        {/* end::Rental Agreement Date */}

        {/* begin::Tenancy date */}
        <div className='w-100 d-flex justify-content-between mb-6'>
          {/* begin::Tenancy commencement date */}
          <div className='fv-row' style={{width: '45%'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Commencement Date</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose tenancy commencement date'
              ></i>
            </label>
            <DatePicker
              autoComplete='off'
              selected={tenancyStartDate}
              dateFormat='yyyy/MM/dd'
              placeholderText='Select date'
              selectsStart
              startDate={tenancyStartDate}
              endDate={tenancyEndDate}
              maxDate={tenancyEndDate}
              onChange={(date: any) => {
                formik.setFieldTouched('tenancy_commencement_date', true, true)
                if (date === null) {
                  setTenancyStartDate(null)
                  formik.setFieldValue('tenancy_commencement_date', '')
                } else {
                  setTenancyStartDate(date)
                  formik.setFieldValue('tenancy_commencement_date', FormatDate(date))
                }
              }}
              className='form-control form-control-lg form-control-solid'
            />
            <div className='h-20px'>
              {formik.touched.tenancy_commencement_date &&
                formik.errors.tenancy_commencement_date && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.tenancy_commencement_date}
                  </div>
                )}
            </div>
          </div>
          {/* end::tenancy commencement date */}

          {/* begin::Tenancy expiration Date */}
          <div className='fv-row' style={{width: '45%'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Expiration Date</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Choose tenancy expiration Date'
              ></i>
            </label>
            <DatePicker
              autoComplete='off'
              selected={tenancyEndDate}
              dateFormat='yyyy/MM/dd'
              placeholderText='Select date'
              selectsEnd
              startDate={tenancyStartDate}
              endDate={tenancyEndDate}
              minDate={tenancyStartDate}
              onChange={(date: any) => {
                formik.setFieldTouched('tenancy_expiration_date', true, true)
                if (date === null) {
                  setTenancyEndDate(null)
                  formik.setFieldValue('tenancy_expiration_date', '')
                } else {
                  setTenancyEndDate(date)
                  formik.setFieldValue('tenancy_expiration_date', FormatDate(date))
                }
              }}
              className='form-control form-control-lg form-control-solid'
            />

            <div className='h-20px'>
              {formik.touched.tenancy_expiration_date && formik.errors.tenancy_expiration_date && (
                <div className='fv-help-block color-red'>
                  {formik.errors.tenancy_expiration_date}
                </div>
              )}
            </div>
          </div>
          {/* end::Tenancy expiration Date */}
        </div>
        {/* end::Tenancy Date */}
      </div>
    </div>
  )
}

export default AddTenantStep4
